import { RefinementList } from 'react-instantsearch-dom'

export default function Brand({ brand }) {
    const defaultBrand = brand ? [brand] : null

    return (
        <div className="mb36">
            <div className="ais-Heading mb18">Prekės ženklas</div>
            <RefinementList
                defaultRefinement={defaultBrand}
                attribute="brand_name"
                limit={10}
                operator="or"
                searchable={true}
                showParentLevel={true}
                showMore={true}
                showMoreLimit={50}
                translations={{
                    showMore(expanded) {
                        return expanded ? 'Rodyti mažiau' : 'Rodyti daugiau'
                    },
                    noResults: 'Rezultatų nerasta...',
                    submitTitle: '',
                    resetTitle: '',
                    placeholder: 'Paieška'
                }}
            />
        </div>
    )
}
